import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import courtTypeService from "../services/court-type-service";

export const courtTypeSearchSchema = z.object({
	search: z.string().optional(),
	court_level: z.string().nullable().optional(),
	include: z.string().optional(),
	page: z.number().nullable().optional(),
	per_page: z.number().optional(),
	courtLevelModel: z.string().optional(),
});

export const courtTypesQueryOptions = (
	search?: z.infer<typeof courtTypeSearchSchema>,
	options?: { enabled: boolean },
) => {
	return queryOptions({
		queryKey: ["court_type", search],
		queryFn: () =>
			courtTypeService.list(
				transformSearch(search, ["search", "court_level", "courtLevelModel"]),
			),
		...options,
	});
};

export const courtTypeQueryOptions = (courtTypeId: string) => {
	return queryOptions({
		queryKey: ["court_type", courtTypeId],
		queryFn: () => courtTypeService.findById(courtTypeId),
	});
};

export const useCourtTypeCreateMutation = (courtTypeId?: string) => {
	return useMutation({
		mutationKey: ["court_type", courtTypeId],
		mutationFn: courtTypeService.create,
		meta: {
			successMessage: "Court type created successfully",
		},
		onSuccess: () =>
			queryClient.invalidateQueries({ queryKey: ["court_type"] }),
	});
};

export const useCourtTypeMutation = (courtTypeId?: string) => {
	return useMutation({
		mutationKey: ["court_type", courtTypeId],
		mutationFn: courtTypeService.upsert,
		meta: {
			successMessage: "Court type updated successfully",
		},
		onSuccess: () =>
			queryClient.invalidateQueries({ queryKey: ["court_type"] }),
	});
};
